import { buildURLObject, QueryObject } from './common';
import { BUYER_CONSULTANCY_SERVICE_AS, BUYER_CONSULTANCY_SERVICE_URL } from './paths';

export function buildBuyerConsultancyServiceURLObject(query: QueryObject = {}) {
  return buildURLObject(BUYER_CONSULTANCY_SERVICE_URL, BUYER_CONSULTANCY_SERVICE_AS, query);
}
